import { z } from 'zod'

const jsonObject = z.record(z.unknown())

export const tcpcatalog5putPutCatalogDraftsCurrentTestCasesTestCaseKeyResponseSchema = jsonObject
export type tcpcatalog5putPutCatalogDraftsCurrentTestCasesTestCaseKeyResponse = z.infer<typeof tcpcatalog5putPutCatalogDraftsCurrentTestCasesTestCaseKeyResponseSchema>
